import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { Button, Popover,DuotonePicker ,   
    __experimentalHStack as HStack,
    __experimentalVStack as VStack,
    __experimentalText as Text,
    __experimentalToolsPanel as ToolsPanel,
    __experimentalToolsPanelItem as ToolsPanelItem,DuotoneSwatch } from '@wordpress/components';

export const VayuBlocksDuotone = ({ duotoneValue, setAttributes ,key }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [popoverAnchor, setPopoverAnchor] = useState();

    const toggleVisible = () => {
        setIsVisible((prev) => !prev);
    };

    const handleduotoneChange = (value) => {

        if(value==='unset'){
            value=undefined;
        }

        setAttributes({ duotone: value });
    }

    const DUOTONE_PALETTE = [
        { colors: ['#8c00b7', '#fcff41'], name: 'Purple and Yellow', slug: 'purple-yellow' },
        { colors: ['#000097', '#ff4747'], name: 'Blue and Red', slug: 'blue-red' },
        { colors: ['#ff008c', '#00ffe5'], name: 'Pink and Aqua', slug: 'pink-aqua' },
        { colors: ['#222222', '#ffffff'], name: 'Dark and Light', slug: 'dark-light' },
        { colors: ['#ff9900', '#6600ff'], name: 'Orange and Violet', slug: 'orange-violet' },
        { colors: ['#00c853', '#ffd600'], name: 'Green and Yellow', slug: 'green-yellow' },
        { colors: ['#1a237e', '#d50000'], name: 'Indigo and Crimson', slug: 'indigo-crimson' },
    ];
    
    const COLOR_PALETTE = [
        { color: '#ff4747', name: 'Red', slug: 'red' },
        { color: '#fcff41', name: 'Yellow', slug: 'yellow' },
        { color: '#000097', name: 'Blue', slug: 'blue' },
        { color: '#8c00b7', name: 'Purple', slug: 'purple' },
    ];

    return (
        <div className="vayu_blocks_duotone_panel">

            <ToolsPanel label={__('Filter','vayu-blocks')} className="vayu_block_dutone_name">
                <ToolsPanelItem
                    className="vayu_blocks_dutone_toolspanel_item"
                    hasValue={() => !!duotoneValue}
                    label={__('Filter','vayu-blocks')}
                    onDeselect={() => handleduotoneChange(undefined)}
                    isShownByDefault
                >
                    <Button
                        ref={setPopoverAnchor}
                        onClick={toggleVisible}
                        className={`block-editor-panel-duotone-settings__dropdown ${isVisible && 'is-open'}`}
                    >
                        <HStack alignment="left">
                            <DuotoneSwatch values={ duotoneValue } />
                            <Text>{__('Duotone','vayu-blocks')}</Text>
                        </HStack>
                    </Button>
                </ToolsPanelItem>
            </ToolsPanel>

            {isVisible && (
                <Popover
                    placement="left-start"
                    className='vayu_blocks_toolspanel_items_popover'
                    anchor={popoverAnchor}
                    onClose={() => setIsVisible(false)}
                    offset={35}
                    resize
                >
                    <VStack  style={{padding:'10px',width: '280px'}}> 
                        <Text>
                            <h4>{__('Duotone','vayu-blocks')}</h4>
                            <p>{__('Create a two-tone color effect without losing your original image.','vayu-blocks')}</p>
                        </Text>

                        <Text>
                            <HStack  spacing="2" wrap={true}>

                                <DuotonePicker
                                    label={__('Filter')}
                                    className='vayu_blocks_dutonepicker_popover'
                                    duotonePalette={DUOTONE_PALETTE}
                                    colorPalette={ COLOR_PALETTE }
                                    value={duotoneValue}
                                    onChange={handleduotoneChange}
                                />

                            </HStack>

                        </Text>

                    </VStack>

                </Popover>
            )}

        </div>
    );
};

